module.exports = __webpack_public_path__ + "static/media/restart.56968976.svg";